// extracted by mini-css-extract-plugin
export default {"header":"Table_header__HE0p-","bot":"Table_bot__lx4y+","iconCircle":"Table_iconCircle__YsUep","text":"Table_text__SES+W"};